import React, { useContext, useEffect, useState } from 'react'
import { ChannelContext } from '@monorepo/infra'
import { PageSpinner } from '@monorepo/components'
import {
    HomepageCarousel,
    SectionZoners,
    SectionNewUserPopUp,
} from '../../organisms'
import { HomepageCarouselHelper } from '../../../helpers/homepage-carousel-helper'
import { StorefrontCarouselSlide } from '../../../models/homepage-carousel-slide'


// Module-level cache — persists across route changes for the session.
// Keyed by channel so a channel switch always fetches fresh data (and caches it).
const slidesCache = new Map<string, StorefrontCarouselSlide[]>()

const Home: React.FC = () => {
    const { selectedChannel } = useContext(ChannelContext)
    const [slides, setSlides] = useState<StorefrontCarouselSlide[]>([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        if (!selectedChannel) return

        // Cache hit → use immediately, no spinner
        if (slidesCache.has(selectedChannel)) {
            setSlides(slidesCache.get(selectedChannel)!)
            setLoading(false)
            return
        }

        // Cache miss → fetch, show spinner, cache result
        setLoading(true)
        HomepageCarouselHelper.getCarouselSlidesAsync(selectedChannel).then((res) => {
            if (res.kind === 'success' && Array.isArray(res.data)) {
                slidesCache.set(selectedChannel, res.data)
                setSlides(res.data)
            }
            setLoading(false)
        })
    }, [selectedChannel])

    if (loading) {
        return <PageSpinner />
    }

    return (
        <>
            <main>
                <HomepageCarousel slides={slides} />
                <SectionZoners />
                <SectionNewUserPopUp />
            </main>
        </>
    )
}

export default Home
